import { useRouter } from "next/router";
import { Logo } from "@olivahealth/oli-ui";
import cx from "classnames";
import Navbar from "../Navbar";
import useNavbar from "../Navbar/useNavbar";
import * as s from "./styles";

export default function Sidebar() {
  const { push } = useRouter();
  const { data } = useNavbar();
  const isLightVariant = data?.isProfessional ?? false;

  return (
    <div
      className={cx(isLightVariant ? s.sidebar : s.sidebarDark)}
      data-testid="sidemenu"
    >
      <div className="mb-10 flex items-center p-2.5">
        <button aria-label="return to home" onClick={() => push("/")}>
          <Logo height={26} color={isLightVariant ? "light" : "white"} />
        </button>
      </div>
      <div className="w-full h-full">
        <Navbar variant={isLightVariant ? "light" : "dark"} />
      </div>
    </div>
  );
}
